import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

import { Transacao } from '../classes/Transacao';

@Injectable({
  providedIn: 'root'
})
export class DestinoTransacaoService {

  public transacaoSelecionada: Transacao;

  constructor(private http: HttpClient) { }

  getDestinosPorIdOrigem(id: number): Observable<any>{
    return this.http.get(`${environment.apiURL}/ConfiguracaoDestino/listarPorIdOrigem/${id}`)
  }

  getDestinosPorMovimentoId(id: number): Observable<any>{
    return this.http.get(`${environment.apiURL}/ConfiguracaoDestino/listarPorMovimento/${id}`)
  }
}
